import { noop, get } from 'lodash/fp';
import { createAsyncActionTypes, createAction, SCOPE_DESTROYED, getBase64Body } from '@mews/framework';
import { AccountType, Sex, TitlePrefix } from '@mews-commander/data-access';
import { createFetchAction, localizeWallClockDateString, getWallClockDateUtcString } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { addCustomer } from '@mews-commander/legacy-entities/src/ducks/customers';
import { updateAccount } from '@mews-commander/legacy-entities/src/actions';
import { addIdentityDocument } from '../identityDocuments/actions';
import { isOpened } from './selectors';
import { prefix, IDENTITY_FORM_SECTION, PROFILE_FORM_SECTION } from './module';

export const SCANNER_DIALOG_OPENED = prefix('SCANNER_DIALOG_OPENED');
export const SCANNER_DIALOG_CLOSED = prefix('SCANNER_DIALOG_CLOSED');
export const SCANNER_RESET = prefix('SCANNER_RESET');
const DOCUMENT_ANALYSIS = prefix('DOCUMENT_ANALYSIS');
export const [DOCUMENT_ANALYSIS_STARTED, DOCUMENT_ANALYSIS_SUCCEEDED, DOCUMENT_ANALYSIS_FAILED] =
    createAsyncActionTypes(DOCUMENT_ANALYSIS);
const DOCUMENT_SAVING = prefix('DOCUMENT_SAVING');
export const [DOCUMENT_SAVING_STARTED, DOCUMENT_SAVING_SUCCEEDED, DOCUMENT_SAVING_FAILED] =
    createAsyncActionTypes(DOCUMENT_SAVING);

export const reset = (scope: string, customerId: string | null) =>
    createAction(SCANNER_RESET, { customerId }, { scope });

export function open(scope: $TSFixMe, customerId: $TSFixMe) {
    return (dispatch: $TSFixMe, getState: $TSFixMe) => {
        if (isOpened(getState(), { scope })) {
            dispatch(close(scope));
        }
        dispatch(createAction(SCANNER_DIALOG_OPENED, { customerId }, { scope }));
    };
}

export function close(scope: $TSFixMe) {
    return (dispatch: $TSFixMe) => {
        dispatch(createAction(SCANNER_DIALOG_CLOSED, undefined, { scope }));
        dispatch(createAction(SCOPE_DESTROYED, undefined, { scope }));
    };
}

export function save(customerId: $TSFixMe, formValues: $TSFixMe, scope: $TSFixMe) {
    return (dispatch: $TSFixMe) => {
        const enterpriseId = getCurrentEnterpriseId();
        const documentValues = get(IDENTITY_FORM_SECTION)(formValues);
        const profileValues = get(PROFILE_FORM_SECTION)(formValues);

        const { birthDateString, ...otherProfileValues } = profileValues;
        const birthDateUtc = getWallClockDateUtcString(birthDateString);

        const accountUpdates = [
            {
                data: {
                    discriminator: AccountType.Customer,
                    value: {
                        id: customerId,
                        birthDate: { value: birthDateUtc },
                        firstName: { value: otherProfileValues.firstName },
                        lastName: { value: otherProfileValues.lastName },
                        nationalityCode: { value: otherProfileValues.nationalityCode },
                        sex: { value: otherProfileValues.gender },
                        title: { value: otherProfileValues.titlePrefix },
                    },
                },
            },
        ];

        const promise = customerId
            ? Promise.all([
                  dispatch(updateAccount({ accountUpdates })),
                  dispatch(addIdentityDocument({ ...documentValues, ownerId: customerId })).catch(noop),
              ]).then(() => customerId)
            : dispatch(addCustomer({ enterpriseId, ...otherProfileValues, birthDateUtc })).then(
                  // @ts-expect-error $TSFixMeError: Binding element 'ownerId' implicitly has an 'any' type.
                  ({ value: { id: ownerId } }) =>
                      dispatch(addIdentityDocument({ ...documentValues, ownerId, overwriteExisting: true })).then(
                          () => ownerId
                      )
              );

        promise.then((id: $TSFixMe) => {
            dispatch(close(scope));
            return id;
        });

        return dispatch(createFetchAction(DOCUMENT_SAVING, promise, { scope }));
    };
}

export function analyze(scope: $TSFixMe, imageData: $TSFixMe) {
    return (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const { identityDocumentsComponent } = container();
        const promise = identityDocumentsComponent
            .analyze({ imageData: getBase64Body(imageData) })
            .then((doc: $TSFixMe) => {
                const {
                    birthDate,
                    gender,
                    firstName,
                    lastName,
                    nationalityCode,
                    documentNumber,
                    documentType,
                    expiration,
                    issuingCountryCode,
                } = doc;
                const birthDateString = localizeWallClockDateString(birthDate);
                const expiryDateString = localizeWallClockDateString(expiration);

                const titlePrefix = gender === Sex.Male ? TitlePrefix.Mister : TitlePrefix.Misses;

                return {
                    documentValues: {
                        expiryDateString,
                        number: documentNumber,
                        type: documentType,
                        issuingCountryCode,
                    },
                    profileValues: { birthDateString, titlePrefix, firstName, lastName, nationalityCode, gender },
                };
            });
        return dispatch(createFetchAction(DOCUMENT_ANALYSIS, promise, { scope }));
    };
}
